module.exports = __webpack_public_path__ + "./img-zone_a4c68aa174bea3f2146964e36073d6cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2016/img-zone.png
// module id = 435
// module chunks = 0